import React from 'react'

export default function PointerClick({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            style={style}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M11.6667 3.4165L10 4.99984'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.24967 6.66667L1.83301 6'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.00033 10L3.41699 11.6667'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6 1.8335L6.66667 4.25016'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.53104 8.07521C7.49873 7.99908 7.48989 7.91504 7.50567 7.83387C7.52145 7.75269 7.56112 7.67807 7.6196 7.6196C7.67807 7.56112 7.75269 7.52145 7.83387 7.50567C7.91504 7.48989 7.99908 7.49873 8.07521 7.53104L17.2419 11.281C17.3235 11.3145 17.3923 11.373 17.4385 11.4481C17.4848 11.5232 17.506 11.611 17.4991 11.6989C17.4923 11.7868 17.4577 11.8703 17.4004 11.9373C17.3431 12.0043 17.266 12.0515 17.1802 12.0719L13.556 12.9394C13.4064 12.9751 13.2696 13.0516 13.1608 13.1603C13.0519 13.2689 12.9753 13.4056 12.9394 13.5552L12.0727 17.1802C12.0525 17.2663 12.0055 17.3437 11.9383 17.4013C11.8712 17.4588 11.7876 17.4936 11.6994 17.5004C11.6113 17.5073 11.5232 17.4859 11.448 17.4395C11.3728 17.393 11.3143 17.3238 11.281 17.2419L7.53104 8.07521Z'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
